import { createI18n } from "vue-i18n";
import daLocaleData from "./locales/da.json";
import core from "./core";

export const SUPPORTED_LOCALES = ["da"];

export interface LocaleData {
    locale: string;
    name: string;
}

export const LOCALE_DATA: Record<string, LocaleData> = {
    da: { locale: "da", name: "Dansk" },
};

const i18n = createI18n({
    locale: "da",
    fallbackLocale: "da",
    globalInjection: true,
    legacy: false,
    messages: {
        da: daLocaleData,
    },
});

const locale = window.localStorage.getItem("slks_locale") || getUsersLocale();
export const localeReady = changeLocale(locale);

export async function changeLocale(locale: string): Promise<void> {
    if (!SUPPORTED_LOCALES.includes(locale)) {
        return Promise.reject(
            new Error(`Unsupported locale ${locale}! Supported locales are ${SUPPORTED_LOCALES.join(", ")}.`)
        );
    }

    (i18n.global.locale.value as string) = locale;

    document.documentElement.setAttribute("lang", locale);
    window.localStorage.setItem("slks_locale", locale);
    core?.api.setApiLocale(locale);

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    if (!(i18n.global.messages as any)[locale]) {
        const { default: localeData } = await import(
            /* webpackChunkName: "locale-[request]" */ `./locales/${locale}.json`
        );
        i18n.global.setLocaleMessage(locale, localeData);
    }
}

function getUsersLocale() {
    if (window.navigator.languages) {
        return (
            window.navigator.languages
                .map((language) => language.substring(0, 2))
                .find((language) => SUPPORTED_LOCALES.includes(language)) || "da"
        );
    } else {
        const nav = window.navigator as unknown as Record<string, string>;
        const usersLocale =
            window.navigator.language || nav.userLanguage || nav.browserLanguage || nav.systemLanguage || "da";
        const locale = usersLocale.substring(0, 2);
        return SUPPORTED_LOCALES.includes(locale) ? locale : "da";
    }
}

export default i18n;
